import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../../../styles/colors';
import { Hint } from './Hint';

export interface LabelProps {
  for: string;
  hint?: string;
}

const StyledLabel = styled.label`
  width: 100%;
  color: ${Colors.grayDark};
  font-size: 1rem;
  margin: 0 0 .5rem;
`;

export const Label: FC<LabelProps> = (props) => {
  return (
    <StyledLabel htmlFor={props.for} style={props.hint && { overflow: 'visible' }}>
      { props.children }
      {
        props.hint &&
        <Hint>{ props.hint }</Hint>
      }
    </StyledLabel>
  );
};
